declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
//import { NgbAddBill } from '../modal/addbill.modal';
//import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, OrderData, SaveiahOrderRequest, ConsumptionGroupItemsController, ConsumptionGroupItemsRequest, StoreLocationMaterialsController, StoreLocationMaterialsRequest, MaterialBatchInaStoreController, SaveMaterialConsumptionEntriesRequest, FinalizeConsumptionEntryRequest, MaterialConsumptionItemsController, MaterialConsumptionItemsRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbAddBill } from '../opbilling/modal/addbill.modal';
import { NgbPayBillModal } from '../opbilling/paybill.modal';
import { NgbBatchDetailModal } from './batchdetail.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
//import { NgbPaymentModal } from './modal/payment.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';
import { ConsumpationData } from '../_MasterClasses/MaterailClasses';




@Component({
    selector: 'consumptionreceiptedit',
    templateUrl: './consumptionreceiptedit.component.html',
    styleUrls: ['./consumptionreceiptedit.component.scss']
    , animations: [routerTransition()]
})

export class ConsumptionReceiptEditComponent implements OnInit {


    public ApiResData: ApiResponseModel;
    @Input() FormattedCode: string;

  public IsEntryUpdated: any;
   // public ActorCode: number = 0;
    //public FormattedCode: number = 0;
    public isNew: boolean = false;
    public isEdit: boolean = false;
   // public Consumptioncode: number;
    public IsExpand: boolean = true;
    public Showarrow: boolean = false;
    public ShowList: boolean = true;
    public ShowPatientDetails: boolean = false;
    public receipt: boolean = true;
    public opbilling: boolean = false;
    public Add: boolean = true;
    public Edit: boolean = false;
    public isRequesting: boolean = false;
    public cash: boolean = false;
    public card: boolean = false;
    public cheque: boolean = false;
    public demanddraft: boolean = false;
    public paytm: boolean = false;
    public FormattedCodedata: any;
    public Code: any;
    public TotalBill: number;
    public NetPayable: number;
    public BranchName: string;
    public FacilityCode: number;
    public ConsumptionGroupCode: any;
  public ConsumptionGroupName: any;
  public StoreCode: any;
  public StoreName: any;
    public ActorCode: number;
    public Date: Date;
    searchTitle: string;
    public SelectedPrescriber: PrescribingDoctor[];
    public SelectedReferral: ReferringDoctor[];
    CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
    CurrentSaveMaterialConsumptionEntriesRequest: SaveMaterialConsumptionEntriesRequest;
    CurrentFinalizeConsumptionEntryRequest: FinalizeConsumptionEntryRequest;
    CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
    SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
    CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



    LoadPatients(FormattedCode: string) {
        this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);



        this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

        this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
        this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
        this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
        this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
        this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
        this.GetPatientInfoByFormattedCodeController();
    }
    GetPatientInfoByFormattedCodeController() {
        this.StartRefreshing();


        this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
                    this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    //this.LoadSign();
                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  constructor(private router: Router,
    public printService: PrintService,
        private actorservice: ActorService,
        private route: ActivatedRoute, private loaderService: SpinnerService,
        private modalService: NgbModal,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
        private filter: Storelistpipe, private spinner: NgxSpinnerService


    ) { }

    ngOnInit() {
      

        this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
      this.Code = this.route.snapshot.paramMap.get('Code');
      this.IsEntryUpdated =  this.route.snapshot.paramMap.get('IsEntryUpdated');      
      this.ConsumptionGroupName = this.route.snapshot.paramMap.get('ConsumptionGroupName');
      this.ConsumptionGroupCode = this.route.snapshot.paramMap.get('ConsumptionGroupCode');
      this.StoreCode = this.route.snapshot.paramMap.get('StoreCode');
      this.StoreName = this.route.snapshot.paramMap.get('StoreName');
        this.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.LoadPatients(this.FormattedCodedata);
        
        this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
        this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveMaterialConsumptionEntriesRequest = new SaveMaterialConsumptionEntriesRequest();
        this.CurrentSaveMaterialConsumptionEntriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentFinalizeConsumptionEntryRequest = new FinalizeConsumptionEntryRequest();
        this.CurrentFinalizeConsumptionEntryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.Date = new Date();
        this.BranchName = AppData.Instance().SelectedBranchName;
      this.GroupItems();
      this.StoreItems();
    }

    CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
    CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
    LoadServicesByCategory() {

        this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
        this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
        //this.pdata = this.CurrentServicesByCategoryCodeController;
        this.GetServicesByCategoryCodeController();

    }
    GetServicesByCategoryCodeController() {
        this.StartRefreshing();
        this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
                  //  this.pdata = this.CurrentServicesByCategoryCodeController;

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }





    BackToProfile() {
        this.ShowList = true;
        this.ShowPatientDetails = false;
        this.Showarrow = false;
    }
    cashdata() {
        this.cash = true;
    }
    carddata() {
        this.card = true;
    }
    chequedata() {
        this.cheque = true;
    }
    demanddraftdata() {
        this.demanddraft = true;
    }
    paytmdata() {
        this.paytm = true;
    }
    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentStoreLocationMaterialsController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentStoreLocationMaterialsController,
                    this.listFilter);
            }
        }
    }
    Consumptioncode: number;
    //public ConsumptionGroupName: string;
    onAssignedToActorCodesurgeon(event: any) {
        
        if (event != null) {
            var Consumptiongroupname = event;
            this.ConsumptionGroupName = Consumptiongroupname;
            //this.GroupItems();
            ///this.del_();
            
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
           /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    del_() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.GroupItems();
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    CurrentMaterialConsumptionItemsRequest: MaterialConsumptionItemsRequest;
    CurrentMaterialConsumptionItemsController: MaterialConsumptionItemsController[];
    GroupItems() {

        this.CurrentMaterialConsumptionItemsRequest = new MaterialConsumptionItemsRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        this.CurrentMaterialConsumptionItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentMaterialConsumptionItemsRequest.ConditionalOperator = 10;
        this.CurrentMaterialConsumptionItemsRequest.ConsumptionCode = this.Code;
        //this.CurrentConsumptionGroupItemsRequest = new Array<ServicesByCategoryCodeController>();
        
        this.GetMaterialConsumptionItemsController();

    }
    GetMaterialConsumptionItemsController() {
        this.StartRefreshing();
        this.actorservice.GetMaterialConsumptionItemsController(this.CurrentMaterialConsumptionItemsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentMaterialConsumptionItemsController = this.ApiResData.Result;                
                    this.AddData();

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
   // StoreCode: number;
    //public StoreName: string;
    onAssignedToActorCodesurgeon2(event: any) {

        if (event != null) {
            this.StoreName = event;
            this.StoreItems();
          /// this.GroupItems();
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    CurrentStoreLocationMaterialsRequest: StoreLocationMaterialsRequest;
    CurrentStoreLocationMaterialsController: StoreLocationMaterialsController[];
    StoreItems() {

        this.CurrentStoreLocationMaterialsRequest = new StoreLocationMaterialsRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;
        
        this.CurrentStoreLocationMaterialsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentStoreLocationMaterialsRequest.ConditionalOperator = 10;
        this.CurrentStoreLocationMaterialsRequest.StoreCode = this.StoreCode;
        this.pdata = this.CurrentStoreLocationMaterialsController;

        this.GetStoreLocationMaterialsController();

    }
    GetStoreLocationMaterialsController() {
        this.StartRefreshing();
        this.spinner.show();
        this.actorservice.GetStoreLocationMaterialsController(this.CurrentStoreLocationMaterialsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentStoreLocationMaterialsController = this.ApiResData.Result;
                    this.pdata = this.CurrentStoreLocationMaterialsController;
                    this.spinner.hide();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    clearData() {
        this.isNew = true;
        this.ShowList = false;

    }
    ExpandData() {
        if (this.IsExpand === true) {
            this.IsExpand = false;
        }
        else {
            this.IsExpand = true;
        }
    }
    ViewItem(l: ConsumpationData) {
        const modalRef = this.modalService.open(NgbBatchDetailModal,
            {
                centered: true,
                size: "lg",
               
            })
        modalRef.componentInstance.ConsumptionGroup = this.ConsumptionGroupName;
        modalRef.componentInstance.StroreLocation = this.StoreName;
        modalRef.componentInstance.MaterialName = l.ItemName;
        modalRef.componentInstance.ItemCode = l.ItemCode;
        modalRef.componentInstance.StoreCode = this.StoreCode;
        modalRef.componentInstance.BatchCode = l.GroupCode;
        modalRef.componentInstance.BatchName = l.SupplierBatchDetails;
        modalRef.componentInstance.Quantity = l.Quantity;
      modalRef.result.then((val: MaterialBatchInaStoreController) => {
            l.Quantity = val.Quantity;
            l.Uom = val.SellingUOM;
            l.ItemCost = val.SellingPrice;
            l.ExpiryDate = val.ExpiryDate;
            l.Material = val.MaterialSpecCode;
            l.MaterialBatchStorage = val.MaterialBatchStorage;
            l.MaterialGroup = 0;
            l.Remarks = "";
            l.Supplier = val.SupplierCode;
            l.SupplierBatchDetails = val.BatchNo;
            l.SupplierMaterialBatch = val.SupplierMaterialBatchCode;
            l.SupplierName = val.SupplierShortName;
            l.Code = 0;
            l.Material = 0;
        
        });

    }
    Cancel() {
        this.router.navigate(['healins/ConsumptionEntry']);
    }
    docedit() {

        const modalRef = this.modalService.open(NgbAddBill,
            {
                centered: true,
                size: "lg",
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.SelectedPrescriber = receivedEntry.make;
            this.SelectedReferral = receivedEntry.value;
           this.LoadServicesByCategory();
            //alert(this.ProvidedName);
        })


    }
    CancelNewOperation() {

        this.ShowList = true;
    }
    back() {
        this.receipt = false;
        this.opbilling = true;
        this.router.navigate(['/healins/opbilling']);
        //this.router.navigate.['/healins/opbilling'];
    }
    payment() {
        const modalRef = this.modalService.open(NgbPayBillModal,
            {
                centered: true,
                size: "lg"
            })
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    CurrentConsumpationData: Array<ConsumpationData>;
    AddData() {

        //this.CurrentConsumpationData = this.CurrentConsumptionGroupItemsController;
        this.CurrentConsumpationData = new Array<ConsumpationData>();
        this.CurrentMaterialConsumptionItemsController.forEach((v, i, d) => {
            var item = new ConsumpationData();
            item.ItemCode = v.ItemCode;
            item.ItemName = v.ItemDescription;
            item.Quantity = v.Quantity;
            item.ItemCost = v.ItemCost;
            item.Uom = v.Uom;
            item.GroupCode = v.GroupCode;
            item.SupplierBatchDetails = v.SupplierBatchDetails;
            this.CurrentConsumpationData.push(item);
        });
        //if (this.CurrentConsumpationData.length == 0) {
        //    this.del_();
        //}
        
        }

          

     


    
   
   // CurrentOrderData: Array<OrderData>;
    AddRow(l: StoreLocationMaterialsController) {
        if (this.CurrentConsumpationData == null) {
            this.CurrentConsumpationData = new Array<ConsumpationData>();
      }
      var itemExists = this.CurrentConsumpationData.find(x => x.ItemName == l.Description);
      if (itemExists != null) {
        return;
      }
        if (this.CurrentConsumpationData != null) {
            var row = new ConsumpationData();
            row.ItemName = l.Description;
            row.ItemCode = l.MaterialSpec;
            row.Quantity = 1;
            row.ItemCost = 0;
            row.SupplierBatchDetails = "0";
           // row.Quantity = 1;
           // row.PackageName = l.CategoryName;
           // row.DiscountAllowed = l.DiscountAllowed;
            //row.ChargeItemCode = 0;
            this.CurrentConsumpationData.push(row);

        }

       // this.TotalBill = this.CurrentConsumptionGroupItemsController.filter((item) => item.ItemCost)
         //   .map((item) => +item.ItemCost)
          //  .reduce((sum, current) => sum + current);
       
       // this.BranchName = AppData.Instance().SelectedBranchName;
       // this.Date = new Date();
        //        alert(l.BasePrice);

        //this.AddData();

    }
    CurrentNewBillData: NewBillData;

    //AddData() {
    //    this.CurrentNewBillData = new NewBillData();
    //    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
        

    //    this.CurrentNewBillData.BillDate = new Date();
    //    this.CurrentNewBillData.BillSource = "Internal";
    //    this.CurrentNewBillData.BillStatus = "";
    //    this.CurrentNewBillData.BillType = "OP";
    //    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    //    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    //    this.CurrentNewBillData.ChargeEntryCode = 0;
    //    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    //    this.CurrentNewBillData.Items = this.CurrentBillDetails;
    //    this.CurrentNewBillData.PrescriberDoctor = this.SelectedPrescriber;
    //    this.CurrentNewBillData.ReferringDoctor = this.SelectedReferral;
    //    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    //    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    //    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    //    this.CurrentNewBillData.TotalDiscount = 0;
    //    this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
    //       .map((item) => +item.ItemRate)
    //        .reduce((sum, current) => sum + current);
    //    this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
    //      .map((item) => +item.ItemRate)
    //        .reduce((sum, current) => sum + current);
    //    //this.CurrentNewBillData
    //    this.SaveData();
       

    //}
  

    SaveData() {
        this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
        this.CurrentSaveBillItemsInfoRequest.ChargeEntry = "0";
        this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
        this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                       // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                       // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                       // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    SaveDataConsumption() {
      this.CurrentSaveMaterialConsumptionEntriesRequest.ConditionalOperator = 10;
      this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionCode = this.Code;
      this.CurrentSaveMaterialConsumptionEntriesRequest.OwnerLocation = AppData.Instance().SelectedBranchCode;
        this.CurrentSaveMaterialConsumptionEntriesRequest.OwnerLocationName = AppData.Instance().UserLoginDetails.FacilityName;
        this.CurrentSaveMaterialConsumptionEntriesRequest.PatientCode = this.SelectedPatientFormattedCode.PatientRegistrationNumber;
        this.CurrentSaveMaterialConsumptionEntriesRequest.PatientFormattedCode = this.FormattedCodedata;
        this.CurrentSaveMaterialConsumptionEntriesRequest.PatientName = this.SelectedPatientFormattedCode.DisplayName;
        this.CurrentSaveMaterialConsumptionEntriesRequest.Remarks = "";
        this.CurrentSaveMaterialConsumptionEntriesRequest.StoreLocation = this.StoreCode;
        this.CurrentSaveMaterialConsumptionEntriesRequest.StoreName = this.StoreName;
        this.CurrentSaveMaterialConsumptionEntriesRequest.UserDepartment = AppData.Instance().SelectedFacilityName;
        this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionGroup = this.ConsumptionGroupCode;
        this.CurrentSaveMaterialConsumptionEntriesRequest.consumptionGroupName = this.ConsumptionGroupName;
        this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionItems = this.CurrentConsumpationData;
        this.actorservice.SaveMaterialConsumptionEntries(this.CurrentSaveMaterialConsumptionEntriesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        
                        // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();
                      this.router.navigate(['healins/ConsumptionEntry']);
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    Finalize() {

        this.CurrentFinalizeConsumptionEntryRequest.ConditionalOperator = 10;
        this.CurrentFinalizeConsumptionEntryRequest.ConsumptionOrderCode = this.Code;
        this.actorservice.FinalizeConsumptionEntry(this.CurrentFinalizeConsumptionEntryRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        // this.Listview = true;
                        //this.EditEmbryo = false;
                        //this.LoadStoreData();
                        //this.AddEmbryo = false;
                        //this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        // this.LoadScansData();
                        this.stopRefreshing();
                        this.router.navigate(['healins/ConsumptionEntry']);
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");

                        //this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        //this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        // this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );
    }
    //alert(this.CurrentBillDetails.length);
    // CurrentBillDetailsEdit: BillDetails;
    Editrow(l: BillDetails) {
        //this.Add = false;

        //this.Edit = true;
        l.Edit = true;
        //this.CurrentBillDetailsEdit = new BillDetails();
        //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
        //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
        //this.CurrentBillDetailsEdit.quantity = l.quantity;
        //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
        //this.CurrentBillDetailsEdit.discount = l.discount;
        //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

    }
    delete(i:number) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            //this.deleterow(i);

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })

    }
    //deleterow(i: number) {
    //    this.CurrentBillDetails.splice(i);
        
    //}
    OnClear(l: BillDetails) {
        l.Edit = false;
    }
    //Payment() {
    //    const modalRef = this.modalService.open(NgbPaymentModal,
    //        {
    //            centered: true,
    //            size: "lg"
               
    //        })
    //    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    //    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    //    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    //    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    //    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    //    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    //    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
    //    modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
    //    modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
    //    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
    //    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
    //    modalRef.componentInstance.ChargeEntryCode = this.CurrentNewBillData.ChargeEntryCode;
    //    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
    //    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
    //    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
    //    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
    //    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
    //    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;

    //    modalRef.componentInstance.Prescriber = this.SelectedPrescriber;
    //    modalRef.componentInstance.Refferal = this.SelectedReferral;

    //}

  printitems() {
    this.printService.printDocument2(this.FormattedCodedata, 0

    );
    this.printService.printDocument("consumptionreceiptPV",
      {
        ActorCodeData: this.ActorCode, FormattedCodeData: this.FormattedCodedata, ConsumptionCodeData: this.Code, ConsumptionGroupName: this.ConsumptionGroupName, StoreName: this.StoreName
      }
    );
  }

}
//export class BillDetails {
//    public ServiceDescription: string;
//    public Quantity: number;
//    public UnitPrice: number;
//    public Discount: number;
//    public ItemRate: number;
//    public RowNumber: number;
//    public Edit: boolean;
//    public ServiceCode: number;
//    public ItemType: string;
//    public ItemGroup: string;
//    public GroupName: string;
//    public IsPackage: boolean;
//    public PackageName: string;
//    public ChargeItemCode: number;
//    public DiscountAllowed: boolean;

//}
//export class PrescribingDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
//export class ReferringDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
// export class ConsumpationData {
  
//    public ItemCode: number;
//    public Quantity: number;
//    public ItemName: string;
//    public Uom: string;
//     public ItemCost: number;
//     public Code: number;
//     public Material: number;
//     public MaterialGroup: number;
//     public Supplier: number;
//     public SupplierName: string;
//     public MaterialBatchStorage: number;
//     //public ItemCost: number;
//     public ExpiryDate: Date;
//     public SupplierBatchDetails: string;
//     public Remarks: string;
//     public GroupCode: number;
//     public SupplierMaterialBatch: number;
//}
